<div class="asset-list-container">
  <lib-dynamic-listing
    module="asset"
    [data]="tableData"
    [columns]="columnConfigs"
    [actions]="actionConfigs"
    [filters]="filterConfigs"
    [totalCount]="totalCount"
    [totalPages]="totalPages"
    [pageIndex]="pageIndex"
    [isLoading]="isLoading"
    [rowsPerPage]="rowsPerPage"
    [showExportButtons]="true"
    [columnPreferenceId]="columnPreferenceId"
    [exportFilename]="exportFilename"
    (filterEvent)="onFilterEvent($event)"
    (actionClicked)="onActionClicked($event)"
    (pageChanged)="onPageChanged($event)"
    (columnPreferenceSaved)="onColumnPreferenceSaved($event)"
    (columnsSelected)="onColumnsSelected($event)"
    (exportCsv)="exportCsv()"
    (exportXlsx)="exportXlsx()"
    (exportPdf)="exportPdf()">
  </lib-dynamic-listing>
</div>

<lib-asset-depreciation-modal
  [visible]="showDepreciationModal"
  (visibleChange)="showDepreciationModal = $event"
  (depreciationApplied)="onDepreciationApplied()">
</lib-asset-depreciation-modal>
